<div class="container">
  <div class="section-left">
    <form [formGroup]="loginForm" (ngSubmit)="login()">
      <div class="logo">
        <img src="assets/images/logo.png" alt="logo" i18n-alt="Logo alt text@@logoAlt" />
      </div>

      <h1>HERO</h1>

      <p i18n="Hero tagline@@heroTagline">
        Your <strong>Partner</strong> in Ordnance Cleanup
      </p>

      <app-input
        leftIcon="ri-user-fill"
        placeholder="Username"
        i18n-placeholder="Username placeholder@@usernamePlaceholder"
        formControlName="username" />

      <app-input
        leftIcon="ri-lock-fill"
        placeholder="Password"
        i18n-placeholder="Password placeholder@@passwordPlaceholder"
        formControlName="password"
        type="password" />

      <button 
        pButton 
        type="submit" 
        class="p-button-block" 
        i18n-label="Sign in button@@signInButton"
        label="Sign In">
      </button>

      <p class="forgot-password-link">
        <a routerLink="/forgot-password" i18n="Forgot password link@@forgotPasswordLink">
          Forgot Password?
        </a>
      </p>
    </form>
  </div>
  <div class="section-right"></div>

  <!-- PrimeNG Toast Component -->
  <p-toast
    position="bottom-center"
    [showTransformOptions]="'translateY(100%) scale(1)'"
    [showTransitionOptions]="'0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55)'" />
</div>